import { maskPhoneNumber, numberOnly } from "../../masks/masks"
import { TPhoneStorage } from "./types"

/** Comprimentos nacionais válidos no Brasil: fixo (10) e celular (11). */
const COMPRIMENTOS_VALIDOS = [10, 11]

/**
 * Máscara brasileira. Delega para maskPhoneNumber para garantir que a
 * digitação continue idêntica à do checkout atual — a biblioteca de
 * numeração NÃO é usada aqui, e o Brasil não paga bundle por ela.
 */
export const formatBR = (value: string): string => maskPhoneNumber(value)

export const isValidBR = (value: string): boolean =>
  COMPRIMENTOS_VALIDOS.includes(numberOnly(value).length)

export const toStorageBR = (value: string): TPhoneStorage => ({
  phone: numberOnly(value),
  ddi: "55",
  iso: "BR",
})
